import React from "react";
import Signup from "../Components/Signup/Signup";

const SignupPage: React.FC = () => {
  return <Signup />;
};

export default SignupPage;
